export default __webpack_public_path__ + "locales/ko-KR/Common.json?hash=99a71671600a7d456689f30c01d22249";